var showSubmit = require('../form-show-submit')

document.addEventListener('click', function (e) {
    var element = e.target.closest('[data-show-t-and-c]')
    //click is part of show terms and conditions modal
    if (element) {
        //find submit button
        var button = document.querySelector('[data-submit]');
        
        if (button) {
            //original click was on google sign-in
            if (element.dataset.showTAndC == 'google') {
            
                button.removeAttribute('href')
                button.setAttribute('data-gapi-begin', 'register')
            
            }
            //original click was on Facebook sign-in
            if (element.dataset.showTAndC == 'FB') {
            
                button.setAttribute('href', button.dataset.href)
                button.removeAttribute('data-gapi-begin')
            
            }
        }
        if (element.dataset.showTAndC == 'continue') {
            // checkbox is required, so form has to be valid
            showSubmit.showHideSubmit(element.form.checkValidity())
        }
    }
})